import { environment } from '../../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { LocaleService, TranslationService, Language } from 'angular-l10n';
import { ApiService } from '../../services/api.service';
import { Onboarding, Status } from '../../models/onboarding';
import { EmployeeDiscount } from '../../models/employee-discount';
import { Observable } from 'rxjs/Observable';
import { AlgGtmService } from '../../services/alg-gtm.service';
import { AlgScontoService } from '../../services/alg-sconto.service';

@Component({
  selector: 'alg-sconto',
  templateUrl: './alg-sconto.component.html',
  styleUrls: ['./alg-sconto.component.scss']
})
export class AlgScontoComponent implements OnInit {
  title = 'Luce&Gas Coop Dipendenti';
  public isLoading: Observable<boolean>;
  public employeeDiscount: EmployeeDiscount = {} as EmployeeDiscount;
  public discountComplete = false;

  constructor(private sconto: AlgScontoService) { }

  ngOnInit() {
    this.sconto.completed.subscribe((val) => {
      this.discountComplete = val;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/alg-sconto/alg-sconto.component.ts